<template>
  <v-form @submit.prevent="addUpdate" ref="form">
    <v-card dense style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">{{fiscal_period.mode}} Calendar Period</span>
            <v-spacer></v-spacer>
            <help-link appId="settings" pageId="calendar-period-create" color="black"></help-link>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin:10px 0px 10px 0px;">
            Error encountered. Please contact support.
        </v-alert>  
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 sm12 style="padding:5px 25px 0px 25px;" >   
                    <v-layout row>
                        <v-flex xs12>
                            <v-text-field v-if="fiscal_period.mode=='Update'" v-model="fiscal_period.fiscalYear" label="Calendar Year" readonly :rules="[rules.required]" hint="Read only if editing record."></v-text-field>
                            <v-select
                                v-if="fiscal_period.mode=='Add'"
                                :items="suggested"
                                :rules="[rules.required]" 
                                item-text="fiscalYear"
                                item-value="fiscalYear"
                                label="Calendar Year"
                                :disabled="disabled"
                                v-model="fiscal_period.fiscalYear"     
                                @change="populateDates"             
                            ></v-select>
                        </v-flex>      
                    </v-layout>        
                    <v-layout row>
                        <v-flex xs12 sm12>
                            <v-text-field v-model="fiscal_period.fiscalStartDate" label="Calendar Start Date" readonly v-on="on" :rules="[rules.required]" hint="Read only. Auto populated."></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap >
                        <v-flex xs12 sm12>
                            <v-text-field v-model="fiscal_period.fiscalEndDate" label="Calendar End Date" readonly :rules="[rules.required]" hint="Read only. Auto populated."></v-text-field>
                        </v-flex>
                    </v-layout>
                    <!-- <v-layout  row style="margin:20px 0px -20px 0px;">  
                        <v-flex xs12>
                            <v-textarea v-model="fiscal_period.remarks" outline label="Remarks" rows="2" color="primary"></v-textarea>
                        </v-flex>      
                    </v-layout> -->
                </v-flex>
            </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions style="height:45px">
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="loading" style="color:white">
                <span v-if="fiscal_period.mode=='Add'">Save</span>
                <span v-if="fiscal_period.mode=='Update'">Update</span>
            </v-btn>
            <v-btn v-if="fiscal_period.mode=='Add'" :disabled="disabled" @click="clearForm" >clear</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import fiscalPeriodsApi from '@/api/fiscalperiods'

export default {
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            disabled: false,
            error: false,       
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    } 
                },
            fiscal_period: {
                mode: 'Add',
                fiscalPeriodId: 0,
                fiscalYear: null,
                fiscalStartDate: null,
                fiscalEndDate: null,
                remarks: null
            },
            menuFiscalStartDate: false,
            menuFiscalEndDate: false,
            suggested: [],
            cutoff_settings: null
        }
    },
    methods: {   
        populateEndDate() {
            this.menuFiscalStartDate=false
            var toDate = this.$moment(this.fiscal_period.fiscalStartDate).add(12, 'months') //add 1 year
            this.fiscal_period.fiscalEndDate = this.$moment(toDate).subtract(1, 'days').format('YYYY-MM-DD') //deduct 1 day
        },
        populateDates() {
            if (this.cutoff_settings) {
                // Get the fiscal year for correct date construction
                const fiscalYear = this.fiscal_period.fiscalYear;

                // Calculate the fiscal start date
                let fiscalStartDate = this.$moment(`${fiscalYear}-${this.cutoff_settings.first_From}`, 'YYYY-DD').startOf('day');
                if (this.cutoff_settings.first_From > this.cutoff_settings.second_To && this.cutoff_settings.second_To !== "EOM") {
                    fiscalStartDate = fiscalStartDate.subtract(1, 'months');
                }

                // Calculate the fiscal end date
                let fiscalEndDate;
                if (this.cutoff_settings.second_To === "EOM") {
                    fiscalEndDate = this.$moment(fiscalStartDate).endOf('month').add(11, 'months').endOf('day');
                } else {
                    fiscalEndDate = this.$moment(`${fiscalYear}-${this.cutoff_settings.second_To}`, 'YYYY-DD').endOf('day');
                    if (this.cutoff_settings.second_To < this.cutoff_settings.first_From) {
                        fiscalEndDate = fiscalEndDate.add(11, 'months');
                    }
                }

                // Format and set the dates
                this.fiscal_period.fiscalStartDate = fiscalStartDate.format('YYYY-MM-DD');
                this.fiscal_period.fiscalEndDate = fiscalEndDate.format('YYYY-MM-DD');
            }
        },
        async setAdd() {
            if (this.suggested.length==0) await this.getUpcoming()
            this.fiscal_period.mode = 'Add'
            this.fiscal_period.remarks = ""
        },
        async setUpdate(data) {
            if (this.suggested.length==0) await this.getUpcoming()

            this.fiscal_period.mode = 'Update'
            this.fiscal_period.fiscalPeriodId = data.fiscalPeriodId
            this.fiscal_period.fiscalYear = data.fiscalYear
            this.fiscal_period.fiscalStartDate = this.$moment(data.fiscalStartDate).format('YYYY-MM-DD')
            this.fiscal_period.fiscalEndDate = this.$moment(data.fiscalEndDate).format('YYYY-MM-DD')
            this.fiscal_period.remarks = ""
        },
        async addUpdate() {
            try {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    const response = await fiscalPeriodsApi.add(this.fiscal_period)
                    if (response&&response.status==200){
                        this.loading = false

                        if (this.fiscal_period.mode == 'Add')
                            this.$router.push(`calendarperiods/${response.data}`)
                        else {
                            this.closeDialog()
                            this.$emit('send', null)
                        }
                            
                    }
                }
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async getUpcoming() {
            try {
                const response = await fiscalPeriodsApi.getUpcoming()
                if (response && response.status==200){
                    this.suggested = response.data.items
                    this.cutoff_settings = response.data.cutOffSettings
                }
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        },
        closeDialog() {
            this.clearForm()
            this.$emit('update:dialogAddEdit', false)
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        }
    },
    created() {
        
    }
}
</script>